export const anatomyConstants = {
  mainColor: "#30A497",
  mainColorBold: "#246d66",
  mainImage: "/heart.png",
  imagePath: "/cardio",
};
